"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styles = require("@material-ui/core/styles");

var _core = require("@material-ui/core");

var _icons = require("@material-ui/icons");

var _SignatureIcon = _interopRequireDefault(require("../../icons/SignatureIcon"));

var _classnames = _interopRequireDefault(require("classnames"));

var palette = _interopRequireWildcard(require("../../shared/oldDocumentSignerUI/palette"));

var _sharedCss = _interopRequireDefault(require("../../shared/oldDocumentSignerUI/sharedCss"));

var _fieldStatusClass = _interopRequireDefault(require("./fieldStatusClass"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var styles = function styles(theme) {
  return _objectSpread(_objectSpread({}, _sharedCss.default.fields), {}, {
    root: {
      position: 'absolute'
    },
    '@font-face': {
      fontFamily: 'Caflischscriptpro',
      src: ["url('https://payrollplus-assets.castandcrew.com/caflischscriptpro-regular.otf')"]
    },
    textField: {
      width: '100%',
      height: '100%'
    },
    signatureButton: {
      position: 'absolute',
      right: 5,
      bottom: 10,
      minWidth: 70,
      width: 70,
      padding: 5,
      background: '#ff0000',
      borderRadius: 3,
      opacity: 0.7,
      '&:hover': {
        background: '#dd0000'
      }
    },
    editButton: {
      position: 'absolute',
      padding: 0,
      right: 5,
      bottom: 5
    },
    input: {
      fontFamily: 'Caflischscriptpro',
      padding: 0,
      color: palette.darkGrey,
      paddingLeft: '5px',
      paddingRight: '5px'
    }
  });
};

var SignatureFieldBase = function SignatureFieldBase(_ref) {
  var isValidated = _ref.isValidated;

  var Component = function Component(props) {
    var name = props.name,
        id = props.id,
        x = props.x,
        y = props.y,
        height = props.height,
        width = props.width,
        handleChange = props.handleChange,
        classes = props.classes,
        value = props.value,
        handleSignatureButtonClick = props.handleSignatureButtonClick,
        clearSignatureButtonClick = props.clearSignatureButtonClick,
        setFieldRef = props.setFieldRef,
        _props$_derived = props._derived,
        isRequired = _props$_derived.isRequired,
        isDisabled = _props$_derived.isDisabled;
    var fieldStyle = {
      top: y,
      left: x,
      height: height,
      width: width,
      fontSize: height * 0.8
    };
    var showButton = (!isValidated || !value) && !isDisabled;
    var inputClass = (0, _classnames.default)(classes.input, (0, _fieldStatusClass.default)(props));
    return /*#__PURE__*/_react.default.createElement("div", {
      className: classes.root,
      style: fieldStyle,
      "data-test-id": "SignatureFieldBase-root-".concat(id)
    }, /*#__PURE__*/_react.default.createElement(_core.TextField, {
      id: name,
      inputRef: function inputRef(e) {
        return setFieldRef(e, y);
      },
      placeholder: isRequired ? 'Required' : '',
      className: classes.textField,
      value: value === null || value === undefined ? '' : value,
      multiline: false,
      type: "text",
      onChange: function onChange(e) {
        return handleChange(e.target.value);
      },
      margin: "none",
      disabled: true,
      InputProps: {
        disableUnderline: false,
        classes: {
          input: inputClass
        },
        style: {
          fontSize: height * 0.8
        }
      }
    }), showButton && /*#__PURE__*/_react.default.createElement(_core.IconButton, {
      className: value ? classes.editButton : classes.signatureButton,
      onClick: function onClick() {
        return handleSignatureButtonClick(id);
      },
      "data-test-id": "SignatureFieldBase-button-".concat(id)
    }, value ? /*#__PURE__*/_react.default.createElement(_icons.Edit, null) : /*#__PURE__*/_react.default.createElement(_SignatureIcon.default, null)), !showButton && /*#__PURE__*/_react.default.createElement(_core.IconButton, {
      className: classes.editButton,
      onClick: function onClick() {
        return clearSignatureButtonClick(id);
      },
      "data-test-id": "SignatureClearFieldBase-button-".concat(id)
    }, /*#__PURE__*/_react.default.createElement(_icons.Clear, null)));
  };

  return (0, _styles.withStyles)(styles)(Component);
};

var _default = SignatureFieldBase;
exports.default = _default;